<template>
  <AppBtn
    :label="label"
    class="border-radius-10 btn-landing"
    :padding="padding"
    @click="url ? openUrl() : buttonAction()"
  />
</template>

<script setup>
import AppBtn from 'components/AppBtn.vue';
import useBookPageEdit from 'src/composables/useBookPageEdit';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  padding: {
    type: String,
    default: '10px 20px',
  },
  url: {
    type: String,
    default: null,
  },
});

function openUrl() {
  window.open(props.url, '__blank');
}

const {
  buttonAction,
} = useBookPageEdit();
</script>
